/**
 * STRAPI_URL — Basis-URL für alle Strapi-API-Anfragen.
 *
 * Wird über REACT_APP_STRAPI_URL in einer .env-Datei gesetzt.
 *
 *  ─── Projekt .env-Dateien ─────────────────────────────────────────────
 *   .env.development → DEV  (npm start / npm run build)
 *   .env.qs          → QS   (npm run start:qs / npm run build:qs  via env-cmd)
 *   .env             → PROD (npm run build:prod  via env-cmd)
 *
 *  Zusätzlich definiert jede .env-Datei REACT_APP_TITLE für den
 *  Browser-Tab-Titel (z.B. "DEV | Innovationsförderung Hessen").
 *
 * ─── Lokale Entwicklung (CRA-Proxy) ───────────────────────────────────
 *  REACT_APP_STRAPI_URL=
 *  (leer — keine Leerzeichen nach "=", keine Anführungszeichen)
 *
 *  Bei leerem Wert verwendet die App relative Pfade (/api/…). Der CRA-
 *  Dev-Server leitet diese an das in package.json deklarierte Strapi-
 *  Backend weiter:
 *    "proxy": "https://hessen-strapi-dev.i-taros.net"
 *
 *  Da der Browser nur localhost:3000 sieht, sind alle Anfragen Same-Origin
 *  und das HttpOnly-Auth-Cookie (SameSite=Lax) wird automatisch mitgesendet.
 *
 *  ⚠  REACT_APP_STRAPI_URL=  ← Leerzeichen nach "=" bedeutet, der Wert
 *     ist " " (ein Leerzeichen, und das ist truthy). Dadurch wird der
 *     Proxy ausgehebelt — jeder API-Call geht an " /api/…" statt an
 *     "/api/…".  Gleiches gilt für Anführungszeichen:
 *     REACT_APP_STRAPI_URL="" speichert den Literal-String "".
 *
 * ─── Lokale Entwicklung (direkt zum Remote — funktioniert nicht) ──────
 *  REACT_APP_STRAPI_URL=https://hessen-strapi-dev.i-taros.net
 *
 *  Cross-Origin-Anfragen von localhost enthalten das SameSite=Lax Auth-
 *  Cookie NICHT.  Login schlägt fehl.
 *
 * ─── Deployment-Umgebungen ────────────────────────────────────────────
 *  DEV  → (leer, CRA-Proxy nach hessen-strapi-dev.i-taros.net)
 *  QS   → https://hessen-strapi-qs.i-taros.net
 *  PROD → https://ha-assets.innovationsfoerderung-hessen.de
 *
 *  Das deployte Portal und Strapi teilen sich dieselbe registrierbare
 *  Domain, daher funktionieren SameSite=Lax-Cookies nativ. Kein Proxy
 *  in package.json nötig.
 *
 * ─── Warum ?? statt || ────────────────────────────────────────────────
 *  ?? (Nullish Coalescing) greift nur bei null / undefined. Ein leerer
 *  String ("") IST nullish, daher löst REACT_APP_STRAPI_URL= den Fallback
 *  aus.  || würde bei "" NICHT greifen, weil "" in JS falsy ist — wir
 *  wollen aber, dass der leere String erhalten bleibt und nicht
 *  überschrieben wird.
 */
export const STRAPI_URL = process.env.REACT_APP_STRAPI_URL ?? 'https://hessen-strapi-dev.i-taros.net';

/**
 * TEMPLATES_URL — PDF-Vorlagen-Generierungsdienst.
 *
 * Wird über REACT_APP_TEMPLATES_URL gesetzt.  Dieser Dienst verwendet
 * seine eigenen Zugangsdaten (unten), nicht das Auth-Cookie.
 *
 *  DEV / QS → https://apiqs.i-taros.net/templates/generate/
 *  PROD     → https://ha-mq.i-taros.net/templates/generate/
 */
export const TEMPLATES_URL = process.env.REACT_APP_TEMPLATES_URL || 'https://apiqs.i-taros.net/templates/generate/';

export const TEMPLATES_SERVICE_SERVER_ID = process.env.REACT_APP_TEMPLATES_SERVICE_SERVER_ID || 'dev';
export const TEMPLATES_SERVICE_CLIENT_ID = process.env.REACT_APP_TEMPLATES_SERVICE_CLIENT_ID || 'client_F6wto_20240409141200452';
export const TEMPLATES_SERVICE_PASSWORD = process.env.REACT_APP_TEMPLATES_SERVICE_PASSWORD || 'strifeberserkers:A*x!~HZ5]V5PkdSx';
